module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "nav"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/",
      "title": "首页"
    }
  }, [_vm._v("首页")])], 1), _vm._v(" "), _vm._l((_vm.navProducts), function(cate1) {
    return _c('li', {
      on: {
        "mouseenter": function($event) {
          _vm.isHovering = true
        }
      }
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'product-list',
          params: {
            cate1: cate1.code
          }
        },
        "title": cate1.remarks
      }
    }, [_vm._v(_vm._s(cate1.title))]), _vm._v(" "), _c('section', {
      staticClass: "show",
      class: {
        'init': !_vm.isHovering
      }
    }, [_c('div', {
      staticClass: "container nav-show"
    }, _vm._l((cate1.children), function(cate2, index) {
      return _c('div', {
        staticClass: "nav-show-content",
        class: {
          w2: cate2.products.length > 8
        }
      }, [_c('router-link', {
        attrs: {
          "to": {
            name: 'product-list',
            params: {
              cate1: cate1.code,
              cate2: cate2.title
            }
          }
        }
      }, [_c('div', {
        staticClass: "nav-show-content-item"
      }, [_vm._v(_vm._s(cate2.title))])]), _vm._v(" "), _c('div', {
        staticClass: "nav-show-content-list"
      }, _vm._l((cate2.products), function(p) {
        return _c('router-link', {
          attrs: {
            "to": {
              name: 'product-detail',
              params: {
                serialId: p.serialId
              }
            }
          }
        }, [_c('span', {
          class: {
            hot: p.isHot
          }
        }, [_vm._v(_vm._s(p.name)), (p.isHot) ? _c('i', [_vm._v("hot")]) : _vm._e()])])
      }))], 1)
    }))])], 1)
  }), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'tax-planing'
      },
      "title": "增值税合法节税与合理避税方法以及费用"
    }
  }, [_vm._v("税务筹划")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/ArticleHome",
      "title": "新闻资讯"
    }
  }, [_vm._v("新闻资讯")])], 1)], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-286a9716!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = 1019
// module chunks = 40